// extracted by mini-css-extract-plugin
export default {"label":"_3M2aO"};